import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  GET_ALL_CUSTOMER,
  CREATE_CUSTOMER,
  GET_CUSTOMER_DETAILS,
  UPDATE_CUSTOMER,
  DELETE_CUSTOMER,
} from "../../constants/ActionTypes";
import axios from 'axios';
import {CisUI} from "../../util/CISUI";
import Config from '../../util/config';


export const getAllCustomer = () => {
  return (dispatch) => {

    dispatch({type: FETCH_START});
    axios.get(Config.apiserver +'customer/customerlist',CisUI().HeaderRequest)
      .then(res => {
      if (res.data.status === 1) {
        // console.log(res.data.data);
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: GET_ALL_CUSTOMER, payload: res.data.data});
      } else {
        dispatch({type: FETCH_ERROR, payload: res.data.msg});
      }
    }).catch(function (error) {
      dispatch({type: FETCH_SUCCESS});
      console.log("Error****:", error.message);
    });
  }
};

export const addCustomer = (values) => {
  return (dispatch) => {

    dispatch({type: FETCH_START});
    axios.post(Config.apiserver +'customer/newcustomer',values,CisUI().HeaderRequest)
      .then(res => {
        if (res.data.status === 1) {
          // console.log(res.data.data);
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: CREATE_CUSTOMER});
          // history.push(redirect);
          CisUI().Notification('success', res.data.msg)
        } else {
          dispatch({type: FETCH_ERROR, payload: res.data.msg});
          CisUI().Notification('error', res.data.msg)
        }
      }).catch(function (error) {
      dispatch({type: FETCH_SUCCESS});
      console.log("Error****:", error.message);
    });
  }
}

export const getCustomer = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.get(Config.apiserver +'customer/customeredit/'+id,CisUI().HeaderRequest)
      .then(res => {
        if (res.data.status === 1) {
          // console.log(res.data.data);
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: GET_CUSTOMER_DETAILS, payload: res.data.data});
        } else {
          dispatch({type: FETCH_ERROR, payload: res.data.msg});
        }
      }).catch(function (error) {
      dispatch({type: FETCH_ERROR});
      console.log("Error****:", error.message);
    });
  }
};

export const updateCustomer = (id, values) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.post(Config.apiserver +'customer/customerupdate/'+id,values,CisUI().HeaderRequest)
      .then(res => {
        if (res.data.status === 1) {
          // console.log(res.data.data);
          // const updateData = getCustomer(id);
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: UPDATE_CUSTOMER});
          dispatch(getCustomer(id))
          CisUI().Notification('success', res.data.msg)
        } else {
          dispatch({type: FETCH_ERROR, payload: res.data.msg});
          CisUI().Notification('error', res.data.msg)
        }
      }).catch(function (error) {
      dispatch({type: FETCH_ERROR});
      console.log("Error****:", error.message);
    });
  }
};

export const DeleteCustomer = (id) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    axios.delete(Config.apiserver + 'customer/customerdelete/' + id, CisUI().HeaderRequest)
      .then(res => {
        if (res.data.status === 1) {
          console.log(res.data.data);
          dispatch({type: FETCH_SUCCESS});
          dispatch({type: DELETE_CUSTOMER, payload: {id}});
          CisUI().Notification('success', res.data.msg)
        } else {
          dispatch({type: FETCH_ERROR, payload: res.data.msg});
          CisUI().Notification('error', res.data.msg)
        }
      }).catch(function (error) {
      dispatch({type: FETCH_ERROR});
      console.log("Error****:", error.message);
    });
  }
};

